<template>
    <div class="container-hts margin-top-20">
        <div class="title-header">
            <h4>{{ dataDetailExcercise.name }}</h4>
        </div>
        
        <DoExcerciseMixedWord :dataDetailExcercise="dataDetailExcercise"
        :userExcerciseClassSchool="userExcerciseClassSchool"
        :listUserExcerciseAnswerQuestion="listUserExcerciseAnswerQuestion" 
        @handleReloadDetailData="handleReloadDetailDataMixedWord"
        v-if="isOpenDoExcerciseMixedWord" />
        <DoExcerciseChooseWord :dataDetailExcercise="dataDetailExcercise"
        :userExcerciseClassSchool="userExcerciseClassSchool"
        :listUserExcerciseAnswerQuestion="listUserExcerciseAnswerQuestion" 
        @handleReloadDetailData="handleReloadDetailDataChooseWord"
        v-if="isOpenDoExcerciseChooseWord" />
        <DoExcerciseChooseBank  ref="DoExcerciseChooseBank" 
        :dataDetailExcercise="dataDetailExcercise"
        :userExcerciseClassSchool="userExcerciseClassSchool" :listQuestion="listQuestion"
        @handleReloadDetailData="handleReloadDetailDataChooseBank"
        :listUserExcerciseAnswerQuestion="listUserExcerciseAnswerQuestion" 
        v-if="isOpenDoExcerciseChooseBank" />
        <DoExcercisePdf ref="DoExcercisePdf" :dataDetailExcercise="dataDetailExcercise" :userExcerciseClassSchool="userExcerciseClassSchool" :listUserExcerciseAnswerQuestion="listUserExcerciseAnswerQuestion" @handleReloadDetailData="handleReloadDetailData"  v-if="isOpenModalDoExcercisePdf"/>
        <DoExcerciseMixedBank :dataDetailExcercise="dataDetailExcercise"
        :userExcerciseClassSchool="userExcerciseClassSchool"
        :listUserExcerciseAnswerQuestion="listUserExcerciseAnswerQuestion" 
        :listQuestionBank="listQuestion"
        @handleReloadDetailData="handleReloadDetailDataMixedBank"
        v-if="isOpenDoExcerciseMixedBank" />
    </div>
</template>

<script>
import {GetDetailExcerciseDoWork} from './../../_api/LessonClassSchoolServices'
import DoExcercisePdf from './_components/DoExcercisePdf.vue'
import {saveUserExcerciseClassSchool} from './../../_api/userExcerciseClassSchool';
import DoExcerciseChooseBank from './_components/DoExcerciseChooseBank'
import DoExcerciseChooseWord from './_components/DoExcerciseChooseWord'
import DoExcerciseMixedWord from './_components/DoExcerciseMixedWord'
import DoExcerciseMixedBank from './_components/DoExcerciseMixedBank'
export default{
    components:{
        DoExcercisePdf,
        DoExcerciseChooseBank,
        DoExcerciseChooseWord,
        DoExcerciseMixedWord,
        DoExcerciseMixedBank
    },
    data(){
        return{
            classSchoolId:0,
            lessonClassSchoolId: 0,
            dataDetailExcercise:{},
            userExcerciseClassSchool:{},
            listUserExcerciseAnswerQuestion:[],
            listQuestion:[],
            isOpenModalDoExcercisePdf:false,
            isOpenDoExcerciseChooseBank:false,
            isOpenDoExcerciseChooseWord:false,
            isOpenDoExcerciseMixedWord:false,
            isOpenDoExcerciseMixedBank:false
        }
    },
    mounted(){
        this.lessonClassSchoolId = this.$route.query.id
        this.classSchoolId = this.$route.query.classSchoolId
        this.getDetailLessonClassSchool()
        //this.saveUserExcercise()
    },
    methods:{
        handleReloadDetailDataMixedBank(){
            this.isOpenDoExcerciseMixedBank =false
            this.getDetailLessonClassSchool(()=>{
                this.isOpenDoExcerciseMixedBank =true
                //this.$refs.DoExcercisePdf.updateDataPage()
            })
        },
        handleReloadDetailDataMixedWord(){
            this.isOpenDoExcerciseMixedWord =false
            this.getDetailLessonClassSchool(()=>{
                this.isOpenDoExcerciseMixedWord =true
                //this.$refs.DoExcercisePdf.updateDataPage()
            })
        },
        handleReloadDetailDataChooseWord(){
            this.isOpenDoExcerciseChooseWord =false
            this.getDetailLessonClassSchool(()=>{
                this.isOpenDoExcerciseChooseWord =true
                //this.$refs.DoExcercisePdf.updateDataPage()
            })
        },
        handleReloadDetailDataChooseBank(){
            this.isOpenDoExcerciseChooseBank =false
            this.getDetailLessonClassSchool(()=>{
                this.isOpenDoExcerciseChooseBank =true
                //this.$refs.DoExcercisePdf.updateDataPage()
            })
        },
        handleReloadDetailData(){
            this.isOpenModalDoExcercisePdf =false
            this.getDetailLessonClassSchool(()=>{
                this.isOpenModalDoExcercisePdf =true
                //this.$refs.DoExcercisePdf.updateDataPage()
            })
            
        },
        saveUserExcercise(){
            let params={
                statusId :1,
                lessonClassSchoolId:this.lessonClassSchoolId,
                classSchoolId:this.classSchoolId,
            }
            saveUserExcerciseClassSchool(params).then(()=>{

            })
        },
        getDetailLessonClassSchool(callback = null) {
            let self = this
            let params={
                lessonClassSchoolId:this.lessonClassSchoolId,
                classSchoolId : this.classSchoolId
            }
            GetDetailExcerciseDoWork(params).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataDetailExcercise = res.data.lessonClassSchoolModel
                    self.userExcerciseClassSchool = res.data.userExcerciseClassSchoolModel
                    self.listUserExcerciseAnswerQuestion = res.data.listUserExcerciseAnswerQuestion
                    self.listQuestion= res.data.listQuestion
                    if(self.dataDetailExcercise.typeUploadExcercise ==5 || self.dataDetailExcercise.typeUploadExcercise ==6){
                        this.isOpenModalDoExcercisePdf = true
                    }
                    else if(self.dataDetailExcercise.typeUploadExcercise ==1){
                        this.isOpenDoExcerciseChooseBank = true
                    }
                    else if(self.dataDetailExcercise.typeUploadExcercise ==2){
                        this.isOpenDoExcerciseMixedBank = true
                    }
                    else if(self.dataDetailExcercise.typeUploadExcercise ==3){
                        this.isOpenDoExcerciseChooseWord = true
                    }else if(self.dataDetailExcercise.typeUploadExcercise ==4){
                        this.isOpenDoExcerciseMixedWord = true
                    }
                    
                    if(callback){
                        callback()
                    }
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.margin-top-20{
    margin-top: 20px;
}
.title-header h4{
    color: #263cb8;
}
</style>